/* eslint-disable */
import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalRoute } from 'react-router-modal';
import moment from 'moment';
import Tooltip from '../../common/Tooltip';
import SelectTimePicker from './SelectTimePicker';
import {getRelevantJobId} from "../../../utils";

const formatNumber = n => (n > 9 ? n : `0${n}`);

const propTypes = {
    job: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired,
    enableModal: PropTypes.bool,
    enableLinkToModal: PropTypes.bool,
    isPreviewMode: PropTypes.bool,
};

export const EditIcon = props => (
    <div className="booking-details-main__time-edit">
        <i className="icon icon-pencil-2" />
    </div>
);

class BookingStartTimeWidget extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { job } = this.props;
        const clockin = job.booking ? job.booking.clock_in : null;
        const originalDatetimeStarted = moment(job.start_datetime);
        const effectiveDatetimeStarted =
            job.booking && job.booking.datetime_started
                ? moment(job.booking.datetime_started)
                : null;
        const passedStartTime = originalDatetimeStarted < moment();

        let color = '#000000';
        let timeTooltipMessage = 'Planned start time';
        let iconTooltipMessage;
        let iconClass;
        const clockedOutLate = false;

        // Computing time tooltip
        if (
            effectiveDatetimeStarted &&
            effectiveDatetimeStarted.valueOf() !=
                originalDatetimeStarted.valueOf()
        ) {
            color = '#FF8C00';
            const timeDiff = moment.duration(
                effectiveDatetimeStarted.diff(originalDatetimeStarted),
            );
            const lateOrEarly = timeDiff < 0 ? 'earlier' : 'later';
            const hoursDiff = Math.abs(timeDiff.hours());
            const minutesDiff = formatNumber(Math.abs(timeDiff.minutes()));
            if (hoursDiff >= 1) {
                timeTooltipMessage = `Started ${hoursDiff}h ${minutesDiff}m ${lateOrEarly}`;
            } else {
                timeTooltipMessage = `Started ${minutesDiff}m ${lateOrEarly}`;
            }
        } else if (effectiveDatetimeStarted) {
            color = '#006400';
            timeTooltipMessage = 'Started on time';
            iconClass = 'icon-check-circle-22 confirm-icon';
        }

        // Computing icon and tooltip
        if (clockin) {
            iconClass = 'icon-check-circle-2 confirm-icon';
            iconTooltipMessage = `Clocked-in at ${moment(
                clockin.clocking_time,
            ).format('HH:mm')}`;

            if (clockin.pending && effectiveDatetimeStarted) {
                iconClass = null;
            } else if (clockin.pending) {
                iconClass = 'icon-warning warning-icon';
                iconTooltipMessage = 'Wrong clock-in location';
            } else if (clockin.overridden) {
                iconClass = 'icon-check-circle-22 confirm-icon';
                iconTooltipMessage = `Manually Clocked in at ${moment(
                    clockin.clocking_time,
                ).format('HH:mm')} by ${clockin.author}`;
            }
        } else if (passedStartTime && !effectiveDatetimeStarted) {
            iconClass = 'icon-warning warning-icon';
            iconTooltipMessage =
                'The freelancer did not clock-in for the shift';
        }

        // Cancelled bookings
        if (['CA', 'FC', 'NS', 'BC'].indexOf(job.booking.status) >= 0) {
            if (!effectiveDatetimeStarted) {
                iconClass = 'icon-error error-icon';
                iconTooltipMessage = 'Effective start time missing';
            } else {
                iconClass = null;
            }
            return (
                <span className="time-container">
                    <Tooltip tooltip="Effective start time">
                        <span className="stale">
                            {effectiveDatetimeStarted
                                ? effectiveDatetimeStarted.format('HH:mm')
                                : 'N/A'}
                        </span>
                    </Tooltip>
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                </span>
            );

            // Settled bookings
        }
        if (effectiveDatetimeStarted) {
            if (this.props.isPreviewMode || !this.props.enableLinkToModal) {
                return (
                    <span className="time-container">
                        <Tooltip tooltip={timeTooltipMessage}>
                            <span style={{ color }}>
                                {effectiveDatetimeStarted.format('HH:mm')}
                            </span>
                        </Tooltip>
                        <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                            <i className={`icon ${iconClass}`} />
                        </Tooltip>
                    </span>
                );
            }

            return (
                <span className="select-time-container">
                    <SelectTimePicker
                        apiFieldName="datetime_started"
                        value={effectiveDatetimeStarted.toISOString()}
                        jobId={getRelevantJobId(job)}
                        bookingId={job.booking.id}
                        notification={this.props.notification}
                        color={color}
                        tooltipMessage={timeTooltipMessage}
                        table={this.props.table}
                    />
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                    <EditIcon />
                </span>
            );

            // Bookings requiring resolution
        }
        if ((clockin && clockin.pending) || (!clockin && passedStartTime)) {
            if (this.props.enableLinkToModal) {
                return (
                    <NavLink
                        to={`${this.props.location.pathname}clockin-out/${job.booking.id}${this.props.location.search}`}
                        style={{
                            color,
                            fontWeight: '300',
                        }}
                        className="time-container"
                    >
                        <Tooltip tooltip={timeTooltipMessage}>
                            <span>
                                {originalDatetimeStarted.format('HH:mm')}
                            </span>
                        </Tooltip>
                        <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                            <i className={`icon ${iconClass}`} />
                        </Tooltip>
                    </NavLink>
                );
            }

            return (
                <span className="time-container">
                    <Tooltip tooltip={timeTooltipMessage}>
                        <span style={{ color }}>
                            {originalDatetimeStarted.format('HH:mm')}
                        </span>
                    </Tooltip>
                    <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                        <i className={`icon ${iconClass}`} />
                    </Tooltip>
                </span>
            );
        }

        // Unsettled bookings (ongoing / future)

        return (
            <span className="time-container">
                <Tooltip tooltip={timeTooltipMessage}>
                    <span style={{ color }}>
                        {originalDatetimeStarted.format('HH:mm')}
                    </span>
                </Tooltip>
                <Tooltip tooltip={iconTooltipMessage} show={iconClass}>
                    <i className={`icon ${iconClass}`} />
                </Tooltip>
            </span>
        );
    }
}

BookingStartTimeWidget.propTypes = propTypes;

export default withRouter(BookingStartTimeWidget);
